import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    rootMain: {
        minWidth: '520px',
        padding: '.5rem'
    },
    root: { padding: '1rem 2.5rem' },
    headerContainer: {
        position: 'relative' as const,
        height: '130px',
        backgroundColor: theme?.app?.clientTheme.colors.primaryColorLight ||
            '#009BDF',
        paddingBottom: '20px'
    },
    topCancelButton: {
        backgroundColor: theme?.app?.clientTheme.colors.primaryColorLight ||
            '#009BDF',
        width: '100%',
        height: '30px',
        display: 'flex',
        justifyContent: 'flex-end',
        // alignItems: 'space-between',
        paddingRight: '10px',
        paddingTop: '10px',
        color: '#fff'
    },
    headerIcon: {
        height: '86px',
        width: '86px'
    },
    paperWidthXl: { width: '40%' },
    buttonContainer: { paddingTop: '2.5rem' },
    smallPaddedText: { padding: '0' },
    paddedText: { padding: '.5rem 0' },
    submitText: { fontSize: '22px' },
    processingText: {
        fontSize: '20px',
        fontWeight: 'bold' as const
    },
    cancelButton: { width: '12rem' },
    amountText: {
        fontSize: '40px',
        marginBottom: '1.5rem'
    },
    amountTextMakerApprover: { fontSize: '40px' },
    disclaimerText: { fontSize: '16px' },
    disclaimerTextMaker: {
        fontSize: '16px',
        marginBottom: '1.5rem'
    },
    paymentCountText: {
        display: 'inline-block' as const,
        fontWeight: 'bold' as const,
        fontSize: '22px',
        padding: '0 6px 0 6px'
    }
});